import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "iconUrl"];
import styled, { css, getSectionBackgroundStyle, useMediaQuery } from 'academy-common-lib/utils/Styling';
import ACIllustration from 'academy-common-lib/components/illustration/ACIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationPreviewSection = styled.section.withConfig({
  displayName: "ACCertificatePreviewSection__CertificationPreviewSection"
})(["min-height:", ";color:", ";display:flex;align-items:center;background-color:white;", " ", " ", ""], ({
  theme
}) => theme.space['1700'], ({
  theme,
  $backgroundColor = 'text-inverse-default'
}) => theme.color[$backgroundColor], ({
  $isMobile,
  theme
}) => $isMobile && css(["flex-direction:column;gap:", ";padding:", ";"], theme.space['800'], `${theme.space['600']} 0 ${theme.space['300']} 0`), ({
  theme
}) => getSectionBackgroundStyle(theme.color['fill-accent-neutral-subtle']), ({
  $spaceCssStyles
}) => $spaceCssStyles);
const ACCertificatePreviewSection = _ref => {
  let {
      title,
      iconUrl
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  const {
    tokenProps
  } = filterTokenProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(CertificationPreviewSection, {
    $isMobile: isMobile,
    $spaceCssStyles: spaceCssStyles,
    children: [/*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "-400",
      marginBlockStart: "-300",
      children: /*#__PURE__*/_jsx(ACIllustration, {
        iconUrl: iconUrl,
        name: "certificate",
        title: title,
        width: 300
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "div",
      marginInlineStart: "600",
      paddingBlock: "500",
      children: /*#__PURE__*/_jsxs(List, {
        marginBlockEnd: "0",
        paddingInlineStart: "800",
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.certificatePreview.point1"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.certificatePreview.point2"
          })
        })]
      })
    })]
  });
};
export default ACCertificatePreviewSection;